import {createAction} from 'typesafe-actions';

import {GeneralSettings} from '../../../components/PanelBank/types';
import {LinePlotSettings} from '../../../components/SettingsDrawer/types';
import * as Types from './types';

export const updateGeneralWorkspaceSettings = createAction(
  '@view/workspaceSettings/general/update',
  action => (ref: Types.Ref, settings: Partial<GeneralSettings>) =>
    action({ref, settings})
);

export const updateLinePlotWorkspaceSettings = createAction(
  '@view/workspaceSettings/linePlot/update',
  action => (ref: Types.Ref, settings: Partial<LinePlotSettings>) =>
    action({ref, settings})
);
